import { DT_PROCESS_TYPES, USERS_SELECTED_ALL } from '../constants';

export const hasGroupFilterValue = val => {
  if (val == null) return false;
  if (Array.isArray(val)) return val.length > 0;
  return true;
};

export const hasActiveGroupFilters = formValues => {
  const { workJourneys, shift, region, premises, jobs, companies } = formValues ?? {};
  return (
    (Array.isArray(workJourneys) && workJourneys.length > 0) ||
    hasGroupFilterValue(shift) ||
    hasGroupFilterValue(region) ||
    hasGroupFilterValue(premises) ||
    hasGroupFilterValue(jobs) ||
    hasGroupFilterValue(companies)
  );
};

export const isAllUsersSelected = urlValue => {
  if (urlValue == null || urlValue === '') {
    return true;
  }
  return urlValue === USERS_SELECTED_ALL;
};

export const serializeUsersSelectedForUrl = formValue => {
  if (!Array.isArray(formValue) || formValue.length === 0) {
    return USERS_SELECTED_ALL;
  }
  return formValue.filter(Boolean).join(',');
};

export const parseUsersSelectedFromUrl = urlValue => {
  if (isAllUsersSelected(urlValue)) {
    return [];
  }
  return urlValue
    .split(',')
    .map(id => id.trim())
    .filter(Boolean);
};

export const resolveUserIdsForReportApi = ({ usersSelected, userId, processType }) => {
  if (processType === DT_PROCESS_TYPES.INDIVIDUAL && userId) {
    return [userId];
  }

  if (processType === DT_PROCESS_TYPES.GROUP) {
    if (isAllUsersSelected(usersSelected)) {
      return [];
    }
    return parseUsersSelectedFromUrl(usersSelected);
  }

  if (usersSelected && !isAllUsersSelected(usersSelected)) {
    return parseUsersSelectedFromUrl(usersSelected);
  }

  if (userId) {
    return [userId];
  }

  return [];
};
